import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { OrderNotesPage } from './order-notes';

@NgModule({
  declarations: [OrderNotesPage],
  imports: [IonicPageModule.forChild(OrderNotesPage)],
})
export class OrderNotesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-notes/order-notes.module.ts